module.exports = __webpack_public_path__ + "img/RIGID TANKER_RHD_THUMB.7baf897a.jpg";